export default __webpack_public_path__ + "static/connected-device-6215f1c36c2481aea1fefb9090b202e4.webp";